import React from 'react';
import image2 from "../../../asset/Image2.jpeg"
import { useNavigate } from 'react-router-dom';
const Banner = () => {
  const navigate = useNavigate();
  return (
    <div className="banner d-flex align-items-center justify-content-between px-4">
      <div className="text-light banner-content">
        <h1 className="mb-1">Welcome to Janpravaha Foundation</h1>
        <p className="mb-0 small">Empowering communities, uplifting lives.</p>
        <div className="buttons">
            <button type='button' onClick={()=>navigate("./about")}>Read More</button>
            <button type='button' onClick={()=>navigate("./founder")}>Founders</button>
        </div>
      </div>
      <img
        src={image2}
        alt="Banner"
        className="img-fluid"
      />
    </div>
  );
};

export default Banner;
